import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { useState } from 'react'
import Sidebar from '@/components/Sidebar'
import MainContent from '@/components/MainContent'
import { isSessionValid } from '@/lib/session'

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: () => {
    const isAuthenticated = isSessionValid()

    if (!isAuthenticated) {
      throw redirect({ to: '/login' })
    }
  },
  component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)

  const handleCollapseToggle = () => {
    localStorage.setItem(
      'sidebarCollapsed',
      !sidebarCollapsed ? 'true' : 'false',
    )
    setSidebarCollapsed(!sidebarCollapsed)
    window.dispatchEvent(new Event('sidebar-collapsed-change'))
  }
  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar collapsed={sidebarCollapsed} onToggle={handleCollapseToggle} />
      <MainContent sidebarCollapsed={sidebarCollapsed}>
        <Outlet />
      </MainContent>
    </div>
  )
}
